<p>ref-checkout-defaults works!</p>
